jQuery ($) ->
    return unless $.fn.mailcheck

    # Validate email addresses
    $('.mailcheck').on 'blur', ->
        $(this).mailcheck

# Source: https://github.com/mailcheck/mailcheck/wiki/List-of-Popular-Domains
            domains: [

# Default domains included
                'aol.com', 'att.net', 'comcast.net', 'facebook.com', 'gmail.com', 'gmx.com', 'googlemail.com',
                'google.com', 'hotmail.com', 'hotmail.co.uk', 'mac.com', 'me.com', 'mail.com', 'msn.com',
                'live.com', 'sbcglobal.net', 'verizon.net', 'yahoo.com', 'yahoo.co.uk',

# Other global domains
                'email.com', 'games.com', 'gmx.net', 'hush.com', 'hushmail.com', 'inbox.com',
                'lavabit.com', 'love.com', 'pobox.com', 'rocketmail.com',
                'safe-mail.net', 'wow.com', 'ygm.com', 'ymail.com', 'zoho.com',

# United States ISP domains
                'bellsouth.net', 'charter.net', 'cox.net', 'earthlink.net', 'juno.com',

# British ISP domains
                'btinternet.com', 'virginmedia.com', 'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk',
                'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com', 'talktalk.co.uk', 'tiscali.co.uk',
                'virgin.net', 'wanadoo.co.uk', 'bt.com',

# Chinese ISP domains
                'sina.com', 'qq.com',

# French ISP domains
                'hotmail.fr', 'live.fr', 'laposte.net', 'yahoo.fr', 'wanadoo.fr', 'orange.fr', 'gmx.fr', 'sfr.fr', 'neuf.fr', 'free.fr',

# German ISP domains
                'gmx.de', 'hotmail.de', 'live.de', 'online.de', 't-online.de', 'web.de', 'yahoo.de',

# Russian ISP domains
                'mail.ru', 'rambler.ru', 'yandex.ru',

# Belgian ISP domains
                'hotmail.be', 'live.be', 'skynet.be', 'voo.be', 'tvcablenet.be',

# Argentinian ISP domains
                'hotmail.com.ar', 'live.com.ar', 'yahoo.com.ar', 'fibertel.com.ar', 'speedy.com.ar', 'arnet.com.ar',

# Domains used in Mexico
                'hotmail.com', 'gmail.com', 'yahoo.com.mx', 'live.com.mx', 'yahoo.com', 'hotmail.es', 'live.com', 'hotmail.com.mx', 'prodigy.net.mx', 'msn.com'

            ]

            suggested: ($input, suggestion) ->
                $message = $input.next('.validation_message')

                if !$message.length
                    $message = $('<div class="gfield_description validation_message" />').hide().insertAfter($input)

                # This next bit is a little complex - we have to create the
                # link the first time, then update it in-place subsequent
                # times - otherwise there's a problem when you have the
                # input focussed and try to click the link
                if !$message.data('mailcheck-suggestion')
# Added tabindex because otherwise when there's a
# message shown and you press tab, the message
# disappears and you're left with nothing focussed
                    $message.html('Did you mean <a href="#" tabindex="-1"></a>?')
                    $message.find('a').click ->
                        $input.val($message.data('mailcheck-suggestion'))
                        $message.remove()
                        return false

                # Remove the error class - it messes up our formatting
                $input.closest('.gfield_error').removeClass('gfield_error')

                # Now we either update the existing suggestion or set it
                # for the first time
                $message.data('mailcheck-suggestion', suggestion.full)
                $message.find('a').text(suggestion.full)

                # Finally fade the message in if necessary
                $message.fadeIn(400)

            empty: ($input) ->
                $input.next('.validation_message[mailcheck-suggestion]').remove()
